export var JudgeCertQuestionType;
(function (JudgeCertQuestionType) {
    JudgeCertQuestionType["SINGLE_CHOICE"] = "SINGLE_CHOICE";
    JudgeCertQuestionType["MULTIPLE_CHOICE"] = "MULTIPLE_CHOICE";
    JudgeCertQuestionType["TRUE_FALSE"] = "TRUE_FALSE";
})(JudgeCertQuestionType || (JudgeCertQuestionType = {}));
export var JudgeCertAttemptStatus;
(function (JudgeCertAttemptStatus) {
    JudgeCertAttemptStatus["IN_PROGRESS"] = "IN_PROGRESS";
    JudgeCertAttemptStatus["SUBMITTED"] = "SUBMITTED";
    JudgeCertAttemptStatus["TIMED_OUT"] = "TIMED_OUT";
})(JudgeCertAttemptStatus || (JudgeCertAttemptStatus = {}));
export var QuestionDifficulty;
(function (QuestionDifficulty) {
    QuestionDifficulty["EASY"] = "EASY";
    QuestionDifficulty["MEDIUM"] = "MEDIUM";
    QuestionDifficulty["HARD"] = "HARD";
})(QuestionDifficulty || (QuestionDifficulty = {}));
//# sourceMappingURL=judge-certification.js.map